import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Sidebar from './AnimatedList';
import "./Services.css";
import "./ServicePage.css";
import Banner from "../Img/Services Banner/Services Banner.jpg";

function Logistics() {
  return (
    <>
      <Image className="fade-in responsive-img" src={Banner} height={500} width="100%" fluid />

      <div className="service-page">
        <section className="service-hero">
          <span className="service-hero__eyebrow">Our Services</span>
          <h1 className="service-hero__title">
            Warehousing &amp; <span>Distribution</span>
          </h1>
          <p className="service-hero__subtitle">
            Secure, strategically located warehousing and distribution facilities
            across India — for piece cargo, bulk cargo and cold-chain requirements.
          </p>
        </section>

        <div className="service-layout">
          <article className="service-content">
            <h2>Warehousing Built for Reliability</h2>
            <p>
              <strong>MMOPL</strong> provides warehousing and distribution services in different
              cities of the world for handling and storage of goods. Our covered warehouses are
              designed for both piece and bulk cargo, allowing goods to be stored in complete
              safety regardless of weather conditions.
            </p>

            <h2>Located Where You Need Us</h2>
            <p>
              Our warehouses are often located right in the ports, making dispatch of containers
              prompt and delay-free. We offer warehouse services as a complete complex — including
              receiving, storage, order picking, packing, labelling and dispatch — as well as
              selective services based on your requirements.
            </p>

            <h2>What We Offer</h2>
            <ul className="service-features">
              <li>Bonded and non-bonded warehousing facilities</li>
              <li>Container Freight Station (CFS) solutions</li>
              <li>Inventory management and real-time stock control</li>
              <li>Order fulfilment and last-mile distribution</li>
              <li>Cold-chain storage for temperature-sensitive cargo</li>
              <li>Pick, pack and re-labelling as per your specifications</li>
            </ul>

            <div className="service-info-banner">
              <div className="service-info-banner__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 21V9l9-6 9 6v12" />
                  <path d="M9 21v-6h6v6" />
                </svg>
              </div>
              <p>
                <strong>Integrated Logistics Solution:</strong> Storage, handling and distribution
                under one contract — one point of accountability for your entire supply chain.
              </p>
            </div>

            <div className="service-cta">
              <h3>Need Warehousing Space?</h3>
              <p>
                Tell us your volume, SKU type and duration — we'll match you with the right
                facility and provide a transparent per-pallet or per-square-foot price.
              </p>
              <Link to="/Contact" className="service-cta__btn">
                Talk to Our Team
              </Link>
            </div>
          </article>

          <Sidebar />
        </div>
      </div>
    </>
  );
}

export default Logistics;